// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { documentGenerationNotification } from 'components/Notifications'

import { 
  setPcnRenewalHighlightedIds,
  getPcnRenewalData,
 } from 'redux/modules/projectTracker'

import {
  assembleQuery,
  postWrapper,
} from 'helpers/api'

const handlePathReportsSubmit = (formats, selected) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {

      const fileName = `Comsearch_Connect_Path_Report_${Date.now()}`
      const pathExportTypes = formats.map(v => v.toUpperCase())
      const underline = 0 //false since portal does not use underline
      const asc = true
  
      const body = {
        fileName,
        pathExportTypes,
        underline,
        asc
      }
      body.pathIds = selected
  
      try {
        const { entity } = await postWrapper(`/legoGateway/paths/export-data`, body)
        dispatch(documentGenerationNotification(entity))
        dispatch(getPcnRenewalData(true))
        dispatch(setPcnRenewalHighlightedIds())
      } catch (err) {
        console.warn(err)
        return handleError(err)
      }
    })
  )
)

export default handlePathReportsSubmit
